//import properties from "./propertiesdev.js";
//import properties from "./propertiestst.js";
//import properties from "./propertiesqal.js";
import properties from "./propertiesprd.js";

const constantes ={};


constantes.rutaOauth = `${properties.API_MM}/security/oauth/token`;
constantes.Authorization=`frontendApp:12345`;
constantes.filesRecupera=`${properties.API_MM}/files/recuperarEntidadArchivo/`;
constantes.filesRecuperaPrincipal=`${properties.API_MM}/files/recuperarArchivoPrincipal/`;
constantes.filesAnula=`${properties.API_MM}/files/anular`;

//APIs para el manejo de la aplicación
constantes.rutaTramite=`${properties.API_MM}/tramites/`;
//constantes.rutaTramite = `http://localhost:8090/api/tramites/`;
constantes.rutaParametros=`${properties.API_MM}/parametros/`;
constantes.rutaTareasComunes=`${properties.API_MM}/tareas-comun/`;
constantes.rutaPagos=`${properties.API_MM}/pagos/`;
constantes.rutaPersona=`${properties.API_MM}/persona/contribuyente/`;
constantes.rutaPersonaObtener = `${properties.API_MM}/persona`;
constantes.rutaAtencion=`${properties.API_MM}/atencion/`;
//constantes.rutaAtencion=`http://localhost:8090/api/atencion/`;
constantes.rutaCatastro=`${properties.API_MM}/geocatastro/`;
constantes.rutacitas = `${properties.API_MM}/citas/`;
//constantes.rutacitas = `http://localhost:8090/api/citas/`;
constantes.API_RENTAS = `${properties.API_MM}/rentas`;
constantes.API_TAREAS_COMUN = `${properties.API_MM}/tareas-comun`;
constantes.API_PERSONA = `${properties.API_MM}/persona`;
constantes.API_PAGOS = `${properties.API_MM}/pagos`;
constantes.API_TRAMITE = `${properties.API_MM}/tramites`;
//constantes.API_TRAMITE = `http://localhost:8090/api/tramites/`;
//constantes.rutaAccesos = `http://localhost:8090/api/accesos/`;
constantes.rutaAccesos = `${properties.API_MM}/accesos/`;

//LINKs de referencia para pagos online
constantes.respuestaPagoTributos = `${properties.LINK_PHP_PAGOS}/proceso/pagos/tributos/respuesta.php`;
constantes.urlIniciaPagoTributo = `${properties.LINK_WEB}/#/pago-tributo`;
constantes.respuestaPagoTramite = `${properties.LINK_PHP_PAGOS}/proceso/pago.php?idArea=`;

//Otras constantes
constantes.MODULO_TRIBUTO_RENTAS = "PAGO-TRIBUTOS-RENTAS";
constantes.version = '1.0.18'

//Credencial para consulta RENIEC
constantes.crendencialReniec = `07414563`;

//Constante IdeFuente
constantes.Ide_Fuente = 101;

constantes.mantenimiento = false;

export default constantes;


// WEBPACK FOOTER //
// ./src/store/constantes.js